const prefix = window.ARCHIVOS_URL_PREFIX || '';

export default function can(Vue) {
  Vue.mixin({
    methods: {
      $archivos(path) {
        return prefix + path;
      }
    }
  });
}
